module.exports = __webpack_public_path__ + "img/mh.5acc521d.svg";